/**
 * Input validation helpers for kiosk text fields.
 *
 * SMG-2797: the Skill Strike kiosk previously accepted any Unicode input for
 * personal-data and screen-name fields (Cyrillic, CJK/"hieroglyphs", emoji,
 * etc.). Those fields must be restricted to standard English keyboard layout
 * characters, i.e. printable ASCII (space through tilde, 0x20-0x7E).
 */

// Matches a string composed solely of printable ASCII characters — the set
// reachable from a standard US/English keyboard layout. Empty strings pass so
// that "required" handling stays the responsibility of the field schema.
export const LATIN_KEYBOARD_REGEX = /^[\x20-\x7E]*$/;

// User-facing message shown when a field contains non-Latin characters.
export const LATIN_KEYBOARD_MESSAGE =
  'Only standard English keyboard characters are allowed.';

// Returns true when every character of `value` is reachable from a standard
// English keyboard (printable ASCII). Null/undefined/empty are treated as valid
// so required-ness stays the field schema's concern.
export const isLatinKeyboardInput = (value: string | null | undefined): boolean => {
  if (value == null) return true;
  return LATIN_KEYBOARD_REGEX.test(value);
};
